// Import hooks
import { useAppSelector } from 'store/hooks';
import { useUserPackets } from 'components/utilities';

export const useResourcesLoaded = () => {
	const { isPacketsLoaded } = useUserPackets();
	const isChannelsLoaded = useAppSelector(({ channels }) => channels.isLoaded);

	return isPacketsLoaded && isChannelsLoaded;
};
